import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useFormikContext } from "formik";
import { formatCurrency } from "../../services/valueFormatters";
import MyDatePicker from "../../atoms/Common/MyDatePicker";
import dayjs from "dayjs";
import { patchPurchaseOrder } from "../../api/purchaseOrders";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

const PODetailHeader = () => {
  const { values, setFieldValue } = useFormikContext();
  console.log(values);
  const { openSnack } = useSnack();

  const subtotal = values.items.reduce(
    (acc, item) => acc + item.subtotal,
    0
  );

  // The original code uses `item.percentageDiscount`, but your object only has `discountPercentage`.
  // If the property is undefined (i.e., item.percentageDiscount), multiplying it gives NaN.
  // Use the correct property name and provide a default of 0 if needed.

  const discount = values.items.reduce(
    (acc, item) => acc + ((item.discountPercentage || 0) * item.price * item.quantity) / 100,
    0
  );

  const tax = values.items.reduce(
    (acc, item) => acc + item.subtotal * item.taxRate / 100,
    0
  );
  values.purchaseOrder.subtotal = subtotal;
  values.purchaseOrder.tax = tax;
  values.purchaseOrder.total =
    subtotal * (1 - values.purchaseOrder.discountPercentage / 100) +
    values.purchaseOrder.tax;

  const handleDatePatch = async (field, value) => {
    if (!value) {
      return;
    }

    const formattedDate = value.format("YYYY-MM-DD");
    const previousValue = values.purchaseOrder[field] ?? null;
    const purchaseOrderId = values.purchaseOrder.id;

    if (!purchaseOrderId) {
      openSnack("No se encontró el ID de la orden de compra", "error");
      return;
    }

    if (previousValue === formattedDate) {
      return;
    }

    await setFieldValue(`purchaseOrder.${field}`, formattedDate);

    try {
      await patchPurchaseOrder(purchaseOrderId, { [field]: formattedDate });
    } catch (e) {
      await setFieldValue(`purchaseOrder.${field}`, previousValue);
      openSnack(handleError(e), "error");
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        <Typography variant="h5">
          Agregar Conceptos orden: {values.purchaseOrder.code}
        </Typography>
        <Typography variant="body2" sx={{color: "#6B7280"}}>
          Razón Social: {values.purchaseOrder.provider?.legalName}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <MyDatePicker
          fullWidth
          label="Fecha de entrega"
          value={values.purchaseOrder.arrivalDate ? dayjs(values.purchaseOrder.arrivalDate) : null}
          onChange={(value) => handleDatePatch("arrivalDate", value)}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </Grid>
      <Grid item xs={2}>
        <MyDatePicker
          fullWidth
          label="Fecha estimada de entrega"
          value={values.purchaseOrder.arrivalEta ? dayjs(values.purchaseOrder.arrivalEta) : null}
          onChange={(value) => handleDatePatch("arrivalEta", value)}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </Grid>
      <Grid item xs={2}>
        <Box
          pt={1}
          pl={1}
          sx={{
            backgroundColor: "#F3F4F6",
            color: "#4B5563",
            outlineColor: "#D1D5DB",
          }}
          borderRadius={"4px"}
          height={"100%"}
        >
          <Typography variant="body2">Descuento Total</Typography>
          <Typography variant="body1">
            { formatCurrency(discount)}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Box
          pt={1}
          pl={1}
          sx={{
            backgroundColor: "#F3F4F6",
            color: "#4B5563",
            outlineColor: "#D1D5DB",
          }}
          borderRadius={"4px"}
          height={"100%"}
        >
          <Typography variant="body2">Subtotal con descuento</Typography>
          <Typography variant="body1">
            {formatCurrency(values.purchaseOrder.subtotal)}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Box
          pt={1}
          pl={1}
          sx={{
            backgroundColor: "#F3F4F6",
            color: "#4B5563",
            outlineColor: "#D1D5DB",
          }}
          borderRadius={"4px"}
          height={"100%"}
        >
          <Typography variant="body2">Impuesto</Typography>
          <Typography variant="body1">
            {formatCurrency(values.purchaseOrder.tax)}
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={4}>
        <Box
          pt={1}
          pl={1}
          sx={{
            backgroundColor: "#AAFFAA",
            color: "#003300",
            outlineColor: "#66FF66",
          }}
          borderRadius={"4px"}
          height={"100%"}
        >
          <Typography variant="body2">TOTAL</Typography>
          <Typography variant="body1">
            {values.purchaseOrder.currency?.code === "EUR" ? "€" : values.purchaseOrder.currency?.symbol} {formatCurrency(values.purchaseOrder.total)}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default React.memo(PODetailHeader);
